module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAAqElEQVQoU2NMTU29zcjIqMJAGNxmTElJcWJiYtrJwMDAgkf9n3///rkzghSkpqYWMTIy9uJRXDRr1qx+sGIQSEtLW8rAwBCFruH///9LZ8+eHQMShysuLCzk/Pr161EGBgZDJA3n3r9/b7N69ervKIpBnOTkZHkmJqbTjIyMov///3/9798/07lz5z6EaYabjOQcRwYGhtUMDAyhs2bN2o/sLAzF+EIQALHrM4Na/CLMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/xiasanjiao.png
// module id = 4GA7
// module chunks = 3